import React from "react";
import { appConfig } from "../../config";
import styles from "./Contact.module.scss";
import { GAevent } from "../../utils/googleAnalyticsHelper";

const Contact = () => {
  const { contact } = appConfig;

  return (
    <div>
      <a href={contact} className={styles.contactBtn} target="blank" onClick={() => GAevent('Guest-User', 'click', 'Contact Button')}>
        Contact Us
      </a>
    </div>
  );
};

export { Contact };
